
import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"
import "intl-tel-input/build/css/intlTelInput.min.css"

export default class extends Controller {
  static targets = [ "tel" ]

  connect() {
    this.iti = intlTelInput(this.telTarget, {
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js",
      initialCountry: "KE",
      autoPlaceholder: "polite",
      // separateDialCode: true,
      // initialCountry: "auto",
      // geoIpLookup: async function (success, failure) {
      //   const resp = await get("https://ipinfo.io", {
      //     responseKind: "jsonp"
      //   })
      //   var countryCode = resp && resp.country ? resp.country : "KE";
      //   success(countryCode);
      // },
    });
  }

  handlePhoneChange(event) {
    event.preventDefault();
    const selectedCountryData = this.iti.getSelectedCountryData();
    const countryCode = selectedCountryData.dialCode;

    if (event.target.value.charAt(0) === "0"){
      event.target.value = event.target.value.slice("1");
    }

    if(!event.target.value.startsWith(countryCode)) {
      const formattedPhoneNumber = countryCode+event.target.value;
      event.target.value = formattedPhoneNumber.replace(/\s+/g, '');
    }
  }

  focusOut(event){
    event.target.value = this.iti.getNumber()
    event.target.value = event.target.value.replace("+", "");
  }
}
